import React, { useState, useRef } from 'react';
import * as S from './styles';
import { useNavigate } from 'react-router-dom';
import { ButtonCarousel } from 'components/ButtonCarousel';

interface CarouselProps {
    images: string[];
}

const MobileCarousel: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const slideRef = useRef<HTMLDivElement>(null);

    const navigate = useNavigate()

    const images = [
        {
            icon: require('assets/image/notices/MobileNews1.jpg'),
            onClick: () => navigate('/moradia-flexivel/')
        },
        {
            icon: require('assets/image/notices/MobileNews2.png'),
            onClick: () => navigate('/proprietarios/')
        },
        {
            icon: require('assets/image/notices/MobileNews3.png'),
            onClick: () => navigate('/moradia-flexivel/')
        }
    ]

    const nextSlide = () => {
        if (currentIndex < images.length - 1) {
            setCurrentIndex((prev) => prev + 1);
        }
    };

    const prevSlide = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prev) => prev - 1);
        }
    };

    return (<>
        <S.CarouselContainer ref={slideRef}>
            {images.map((image, index) => (
                <S.Slide
                    key={index}
                    src={image.icon}
                    alt={`Slide ${index}`}
                    active={index === currentIndex}
                    onClick={image.onClick}
                />
            ))}
        </S.CarouselContainer>
        <S.ButtonContainer>
            <ButtonCarousel onClick={prevSlide} direction="left" />
            {images.map((_: any, i: number) => {
                return <S.Bullet key={i} active={currentIndex === i ? true : false} />;
            })}
            <ButtonCarousel onClick={nextSlide} direction="right" />
        </S.ButtonContainer>
    </>
    );
};

export default MobileCarousel;
